/**
 * @generated SignedSource<<3b80b36f36a91395d89d10f5ada39760>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type SearchLinkedResultCategory = "child" | "mentionedBy" | "mentions" | "similar" | "%future added value";
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "code" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "organization" | "organization_status_update" | "page" | "plan" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "risk" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchGraphDeal_AtlassianSearchPage$data = {
  readonly entity: {
    readonly dealClosedAt?: string | null;
    readonly lastActivity?: {
      readonly event: string | null;
      readonly lastActivityAt: string | null;
    } | null;
    readonly owners?: ReadonlyArray<{
      readonly thirdPartyUser: {
        readonly name: string | null;
      } | null;
    } | null> | null;
    readonly parent?: {
      readonly displayName?: string | null;
      readonly id?: string;
    } | null;
    readonly stage?: string | null;
  } | null;
  readonly id: string;
  readonly lastModifiedDate: string | null;
  readonly linkedResults: ReadonlyArray<{
    readonly category: SearchLinkedResultCategory;
    readonly connectorType: string | null;
    readonly description: string;
    readonly id: string;
    readonly integrationId: string | null;
    readonly lastModifiedDate: string | null;
    readonly providerId: string | null;
    readonly subtype: string | null;
    readonly title: string;
    readonly type: SearchResultType;
    readonly url: string;
  }> | null;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "searchGraphDeal_AtlassianSearchPage";
};
export type searchGraphDeal_AtlassianSearchPage$key = {
  readonly " $data"?: searchGraphDeal_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchGraphDeal_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "url"
},
v2 = {
  "kind": "ScalarField",
  "name": "title"
},
v3 = {
  "kind": "ScalarField",
  "name": "lastModifiedDate"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__isdealownersenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "searchGraphDeal_AtlassianSearchPage",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "stage"
            },
            {
              "kind": "ScalarField",
              "name": "dealClosedAt"
            },
            {
              "concreteType": "ExternalDealLastActivity",
              "kind": "LinkedField",
              "name": "lastActivity",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "lastActivityAt"
                },
                {
                  "kind": "ScalarField",
                  "name": "event"
                }
              ]
            },
            {
              "condition": "__relay_internal__pv__isdealownersenabledrelayprovider",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "concreteType": "ExternalUser",
                  "kind": "LinkedField",
                  "name": "owners",
                  "plural": true,
                  "selections": [
                    {
                      "concreteType": "ThirdPartyUser",
                      "kind": "LinkedField",
                      "name": "thirdPartyUser",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "name"
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "kind": "LinkedField",
              "name": "parent",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "displayName"
                    }
                  ],
                  "type": "ExternalCustomerOrg"
                }
              ]
            }
          ],
          "type": "ExternalDeal"
        }
      ]
    },
    {
      "concreteType": "SearchLinkedResult",
      "kind": "LinkedField",
      "name": "linkedResults",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v2/*: any*/),
        (v1/*: any*/),
        {
          "kind": "ScalarField",
          "name": "type"
        },
        {
          "kind": "ScalarField",
          "name": "description"
        },
        (v3/*: any*/),
        {
          "kind": "ScalarField",
          "name": "category"
        },
        {
          "kind": "ScalarField",
          "name": "subtype"
        },
        {
          "kind": "ScalarField",
          "name": "integrationId"
        },
        {
          "kind": "ScalarField",
          "name": "providerId"
        },
        {
          "kind": "ScalarField",
          "name": "connectorType"
        }
      ]
    }
  ],
  "type": "SearchResultGraphDocument"
};
})();

(node as any).hash = "a67dcd516788ae186b2f421b3cb9f8c0";

export default node;
